module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n    <ul class=\"dropdown js-dropdown\" aria-live=\"assertive\">\n        <li class=\"pv-h\">\n            <button class=\"filter\" tabindex=\"0\" aria-haspopup=\"listbox\" aria-expanded=\"false\">More Providers</button>\n            <ul class=\"content provider__list__item\" role=\"listbox\" tabindex=\"-1\">\n                ")
    ;  for(var key in providers) { 
    ; __append("\n                    <li role=\"option\"><a href=\"#\" data-providerId=\"")
    ; __append(escapeFn( providers[key].providerID ))
    ; __append("\" class=\"vue-focusable\" role=\"button\" tabindex=\"0\" aria-label=\"")
    ; __append(escapeFn( providers[key].providerName ))
    ; __append("\">")
    ; __append(escapeFn( providers[key].providerName ))
    ; __append("</a></li>\n                ")
    ;  } 
    ; __append("\n            </ul>\n        </li>\n    </ul>\n</div>\n")
  }
  return __output;

}